// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1QrQE","col":"styles_col__2j7u-","fulfillmentStatus":"styles_fulfillmentStatus__2A9X0","emailCol":"styles_emailCol__Idxhp"};